import { type WeekChange, type WeekCount, monthDay } from "@/lib/gantt";
import { css, cx } from "@styled-system/css";

const cell = css({
  position: "absolute",
  top: "0",
  bottom: "0",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  fontFamily: "mono",
  fontSize: "12",
  color: "text.subtle",
  borderLeft: "[1px solid var(--oks-colors-border)]",
});

interface ChartStripProps {
  counts: WeekCount[];
  /** px from the track's left edge for each Monday */
  xOf: (week: string) => number;
  weekW: number;
}

/** The chart's bottom row: active phases per week, every phased project. */
export function ChartWeekStrip({ counts, xOf, weekW }: ChartStripProps) {
  return (
    <>
      {counts.map((w) => (
        <span
          key={w.week}
          className={cell}
          style={{ left: xOf(w.week), width: weekW }}
          title={`Week of ${monthDay(w.week)}: ${w.count} active phase${w.count === 1 ? "" : "s"}`}
        >
          {w.count}
        </span>
      ))}
    </>
  );
}

const list = css({
  display: "flex",
  flexWrap: "wrap",
  gap: "4",
  listStyle: "none",
  m: "0",
  p: "0",
});
const item = css({
  fontFamily: "mono",
  fontSize: "[11px]",
  lineHeight: "[16px]",
  px: "6",
  py: "2",
  borderRadius: "2",
  color: "text.subtlest",
  border: "default",
});
const changed = css({
  color: "text.warning",
  borderColor: "border.warning",
  fontWeight: "medium",
});

/** Before → after mode for the drag preview. Changed weeks are marked "2 → 3". */
export function WeekChangeStrip({ weeks }: { weeks: WeekChange[] }) {
  return (
    <ul className={list}>
      {weeks.map((w) => (
        <li
          key={w.week}
          className={cx(item, w.changed && changed)}
          data-changed={w.changed ? "true" : undefined}
        >
          {monthDay(w.week)}: {w.changed ? `${w.before} → ${w.count}` : w.count}
        </li>
      ))}
    </ul>
  );
}
